import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

export default function () {
    const gallery = $('.light-gallery');

    if (!gallery.length) return;

    gallery.lightGallery({
        thumbnail: true,
        download: false,
        counter: false,
    });

    $(document).on('click', '.shop-gallery-item', function () {
        let index = $(this).data('index');
        let gallery = $(`[data-lg-src=${$(this).attr('data-lg-link-to-src')}]`);
        gallery.children().eq(index).trigger('click');
        // debugger
    });
}
